/**
 * Determines whether a hostname represents a local development environment.
 *
 * Matches:
 * - "localhost" or "localhost:PORT"
 * - "*.localhost" (e.g. app.localhost:3000)
 * - "127.0.0.1"
 * - "*.local.*" subdomains (e.g. gih-22.local.dev.ag.zones.dtn.com)
 */
export const isLocalDev = (hostname) => {
    var _a;
    // Strip port if present
    const host = (_a = hostname.split(":")[0]) !== null && _a !== void 0 ? _a : hostname;
    return (host === "localhost" ||
        host === "127.0.0.1" ||
        host.endsWith(".localhost") ||
        host.includes(".local."));
};
